import React from "react";

export default function AppFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="fixed bottom-0 left-0 right-0 z-50 w-full border-t border-slate-200 bg-white/80 backdrop-blur">
      <div className="mx-auto max-w-7xl px-4 py-3 text-center text-xs text-slate-500">
        © {year} ScribeInAI. All rights reserved.
      </div>
    </footer>
  );
}

